import React from 'react';

export const About = () => (
    <div>
        <h2>About Page</h2>
        <p>Coming soon</p>
    </div>
)
